import { gql } from '@apollo/client';

const orgsAndUnitsFragment = gql`
  fragment OrgAndUnitsFields on MddapOrganization {
    Id
    Name
    MddapOrgUnits {
      Id
      Name
      Fei
      IsActive
    }
  }
`;

export default orgsAndUnitsFragment;
